import type { PropsWithChildren } from 'react';
import React from 'react';
import { Spinner } from './Spinner';

type LoadingOverlayProps = PropsWithChildren<{
  show?: boolean;
  noSpinner?: boolean;
}>;

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show = false, noSpinner, children }) => {
  if (!show) {
    return (
      <></>
    );
  }

  return (
    <div className="absolute left-0 top-0 z-[999999] flex h-full w-full flex-col items-center justify-center gap-4 bg-white">
      {children}
      {!noSpinner && (
        <div>
          <Spinner/>
        </div>
      )}
    </div>
  );
};